export default __webpack_public_path__ + "static/media/collect_suggestion.ea1b31d3.png";